import { useState } from 'react';
import { useBill } from '../bill.tsx';
import { useStore } from '../store.tsx';
import { useToast } from '../ui.tsx';

/**
 * ทางลัด — กรอกรหัสสินค้าด้วยแป้นตัวเลข
 *
 * ★ ลอกจาก components/SearchProdCode.js ★
 *
 * พนักงานที่ทำงานมานานจำรหัสเมนูที่ขายบ่อยได้ การพิมพ์ `1003*2` แล้วกด Enter
 * เร็วกว่าไล่หารูปในกริดมาก — เป็นฟีเจอร์ที่คนคล่องใช้ตลอดเวลา
 *
 * รูปแบบ
 *   1003     เพิ่มสินค้ารหัส 1003 จำนวน 1
 *   1003*2   เพิ่มสินค้ารหัส 1003 จำนวน 2
 *
 * ปุ่ม X บนแป้นคือเครื่องหมาย * (ของเดิมเขียนว่า X แต่ใส่ค่าเป็น *)
 */
export function ShortcutPad() {
  const store = useStore();
  const bill = useBill();
  const toast = useToast();
  const [code, setCode] = useState('');

  const press = (key: string) => setCode((prev) => prev + (key === 'X' ? '*' : key));

  const enter = () => {
    if (bill.payload.billType === '') {
      toast('ยังไม่ได้สร้างบิล', 'warn');
      return;
    }
    if (code === '') {
      toast('กรุณากรอกรหัสสินค้า', 'warn');
      return;
    }
    if (code.split('*').length > 2) {
      toast('รูปแบบผิดพลาด', 'crit');
      return;
    }

    const [prodCode = '', qtyText = ''] = code.split('*');
    const qty = qtyText === '' ? 1 : Number(qtyText);
    if (!Number.isInteger(qty) || qty <= 0) {
      toast('จำนวนต้องเป็นจำนวนเต็มบวก', 'crit');
      return;
    }

    const product = store.products.find((p) => p.code === prodCode);
    if (!product) {
      // ปุ่มส่วนลดก็กดผ่านทางลัดได้ เพราะของเดิมมันคือสินค้าตัวหนึ่ง
      const button = store.discountButtons.find((d) => d.code === prodCode);
      if (button) {
        bill.applyDiscountButton(button);
        setCode('');
        return;
      }
      toast('ไม่พบรายการสินค้า', 'crit');
      return;
    }

    for (let i = 0; i < qty; i++) bill.addProduct(product);
    setCode('');
  };

  return (
    <div className="shortcut">
      <div className="code-row">
        <span>รหัสสินค้า :</span>
        <span className="code-box">{code}</span>
      </div>

      <div className="pad">
        <div className="nums">
          {['7', '8', '9', '4', '5', '6', '1', '2', '3', 'X', '0'].map((key) => (
            <button key={key} type="button" className="key" onClick={() => press(key)}>
              {key}
            </button>
          ))}
        </div>
        <div className="ops">
          <button type="button" className="key" onClick={() => setCode((p) => p.slice(0, -1))}>
            ลบ
          </button>
          <button type="button" className="key" onClick={() => setCode('')}>
            ล้าง
          </button>
          <button type="button" className="key enter" onClick={enter}>
            Enter
          </button>
        </div>
      </div>

      <p className="hint">
        พิมพ์รหัสแล้วกด Enter · ใส่จำนวนด้วยเครื่องหมาย X เช่น <b>1003 X 2</b>
      </p>
    </div>
  );
}
